// extracted by mini-css-extract-plugin
export default {"targetPlusSvg":"TargetPlus_targetPlusSvg__j0wS6"};